import React from 'react';
import PoppyPokerSite from './PoppyPokerSite';

function App() {
  return <PoppyPokerSite />;
}

export default App;
